import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { customiseTemplateSchema, type CustomiseTemplateFormValues } from '../schemas/documentTemplate.schema';
import type { DocumentTemplateSummary } from '../types/documentTemplates.types';
import { applyServerFieldErrors } from '../utils/formErrors';
import { useCustomiseTemplateMutation } from './useCustomiseTemplateMutation';
import { useTemplateOwnerContext } from './useTemplateOwnerContext';

export function useCustomiseTemplateForm(source: DocumentTemplateSummary, onDone: () => void) {
  const navigate = useNavigate();
  const { isInternal, homeDealerId } = useTemplateOwnerContext();
  const mutation = useCustomiseTemplateMutation(source.id);
  const form = useForm<CustomiseTemplateFormValues>({
    mode: 'onBlur',
    resolver: zodResolver(customiseTemplateSchema),
    defaultValues: { name: source.name, key: source.key, dealerId: isInternal ? '' : (homeDealerId ?? '') },
  });

  const submit = form.handleSubmit((values) => {
    mutation.mutate(values, {
      onSuccess: (variant) => {
        onDone();
        navigate(`/admin/document-templates/${variant.id}`);
      },
      onError: (error) => {
        if (!applyServerFieldErrors(error, form.setError)) {
          toast.error((error as Error).message);
        }
      },
    });
  });

  return { form, submit, isSaving: mutation.isPending };
}
